import { AppSubStore, AppSubStoreArgs } from "@/store/types";
import { action, computed, makeObservable, observable, runInAction } from "mobx";
import { PlatformAccountState } from "@/store/platform-info/types";
import { GatedFeature, GateUsage } from "@/store/feature-gates/types";
import type { CommercialPlanKey } from "@/modules/commercial-plans";

export class SettingsSubscriptionManagementPageStore extends AppSubStore {
  public isAppleManagedDialogOpen = false;
  public selectedCommercialPlanKey: CommercialPlanKey | null = null;

  constructor(injectedDeps: AppSubStoreArgs) {
    super(injectedDeps);

    makeObservable(this, {
      isAppleManagedDialogOpen: observable,
      selectedCommercialPlanKey: observable,
      hasActiveSubscription: computed,
      openAppleManagedDialog: action,
      closeAppleManagedDialog: action,
      openSubscriptionModal: action,
      selectCommercialPlan: action,
      refreshUsage: action,
      notesUsage: observable,
      chatUsage: observable,
      isUsageLoading: observable,
    });
  }

  get hasActiveSubscription() {
    return this.store.platformInfo.accountState === PlatformAccountState.Active;
  }

  notesUsage: GateUsage | undefined = undefined;
  chatUsage: GateUsage | undefined = undefined;
  isUsageLoading = false;

  public openAppleManagedDialog() {
    this.isAppleManagedDialogOpen = true;
  }

  public closeAppleManagedDialog() {
    this.isAppleManagedDialogOpen = false;
  }

  public selectCommercialPlan(planKey: CommercialPlanKey) {
    this.selectedCommercialPlanKey = planKey;
  }

  async refreshUsage(): Promise<void> {
    this.isUsageLoading = true;
    try {
      const [notes, chat] = await Promise.all([
        this.store.featureGates.checkGate(GatedFeature.NoteCreate),
        this.store.featureGates.checkGate(GatedFeature.ChatMessageSend),
      ]);

      runInAction(() => {
        this.notesUsage = notes;
        this.chatUsage = chat;
      });
    } finally {
      runInAction(() => {
        this.isUsageLoading = false;
      });
    }
  }

  public openSubscriptionModal() {
    this.store.platformInfo.openSubscribeNowInterstitial();
  }
}
